import { Button } from "@/components/ui/button";
import { Inbox } from "lucide-react";

export function EmptyState({ icon: Icon = Inbox, title, description, actionLabel, onAction, testId }) {
    return (
        <div className="flex flex-col items-center justify-center text-center py-16 px-6" data-testid={testId}>
            <div className="w-14 h-14 rounded-2xl bg-muted flex items-center justify-center mb-4">
                <Icon className="w-6 h-6 text-muted-foreground" />
            </div>
            <h3 className="font-heading text-lg font-semibold">{title}</h3>
            {description && <p className="text-sm text-muted-foreground mt-1 max-w-sm">{description}</p>}
            {actionLabel && (
                <Button className="mt-5" onClick={onAction} data-testid={testId ? `${testId}-action` : undefined}>
                    {actionLabel}
                </Button>
            )}
        </div>
    );
}
